import * as sendFormBlog from "./formHomeBlog";
import { useState } from "react";
import styles from "./styles.module.scss";
import logger from "../../utils/logger";
import Image from "next/legacy/image";
import { gaEvents } from "../../utils/ga_events";

interface Form {
  name: string;
  email: string;
  valor: number;
  botField: string;
}

interface Target {
  target: {
    name: string;
    value: string | number;
  };
}

const formInitialState: Form = {
  name: "",
  email: "",
  valor: 0,
  botField: "",
};

export const FormBlog = () => {
  const [form, setForm] = useState(formInitialState);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleReset = () => {
    setForm(formInitialState);
  };

  const handleSetForm = ({ target: { name, value } }: Target) => {
    setForm((form) => ({ ...form, [name]: value }));
  };

  const confirm = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setShowConfirm(true);
  };

  const submit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setLoading(true);
    // send api request
    await sendFormBlog
      .onSubmit(form)
      .then(() => {
        gaEvents.blog.generateLead('assinar-newsletter:confirmar')
        handleReset();
      })
      .catch((error: unknown) => {
        logger.error("Form blob submit", error as Error);
      })
      .finally(() => {
        setLoading(false);
        setShowConfirm(false);
      });
  };

  return (
    <>
      {showConfirm ? (
        <form onSubmit={submit} className={styles.newsletterForm}>
          <div className={styles.check}>
            <p>Está correto?</p>
            <div className={styles.dados}>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <p>Nome: </p>
                    </td>
                    <td>
                      <span>{form.name}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>E-mail: </p>
                    </td>
                    <td>
                      <span>{form.email}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Cálculo: </p>
                    </td>
                    <td>
                      <span>{form.valor}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className={styles.actions}>
              <button type="submit">
                {loading ? "carregando..." : "Enviar"}
              </button>
              <button type="button" onClick={() => setShowConfirm(false)}>
                Não
              </button>
            </div>
          </div>
        </form>
      ) : (
        <form
          onSubmit={confirm}
          onReset={handleReset}
          className={styles.newsletterForm}
        >
          <h3>Quer saber mais?</h3>
          <p>Assine nossa newsletter e receba os conteúdos e seu e-mail</p>
          <input
            placeholder="Seu nome"
            value={form.name}
            name="name"
            onChange={handleSetForm}
          />
          <input
            placeholder="Seu melhor e-mail"
            value={form.email}
            name="email"
            onChange={handleSetForm}
          />
          <div className={styles.inputCalc}>
            <Image
              width={190}
              height={37}
              src="https://finanzero.com.br/images/uploads/2021/09/calc-newsletter.png"
              alt=""
            />
            <input
              placeholder="valor"
              value={form.valor}
              name="valor"
              onChange={handleSetForm}
            />
          </div>
          {/* Input para preenchimento de bots, caso preenchido, não envia */}
          <input
            className={styles.botsField}
            placeholder="Cidade"
            value={form.botField}
            name="botField"
            onChange={handleSetForm}
          />

          <div>
            <button type="submit">Confirmar</button>
          </div>
        </form>
      )}
    </>
  );
};
